import axios from 'axios';
import { normalize, schema } from 'normalizr';
import { getJwtCookie } from '../../utils/cookie-utils';
import COLLECTIONS_CONFIG from '../constants/collections-config';

const widget = new schema.Entity( 'widgets', {}, {
    processStrategy: ( value, parent ) => {
        return { ...value, canvasId: parent.id };
    }
} );

const canvas = new schema.Entity( 'canvases', {
    widgets: [widget]
} );

const collection = new schema.Entity( 'collections', {
    canvases: [canvas]
} );

const userPreferences = {
    collections: [collection]
};

export default class DashboardService{
    constructor( baseURL ){
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        };

        if( getJwtCookie() ){
            headers.Authorization = `Bearer ${getJwtCookie()}`;
        }

        this.instance = axios.create( {
            baseURL,
            headers
        } );
    }

    fetchCollections(){
        const normalizedData = normalize( COLLECTIONS_CONFIG, userPreferences );
        return Promise.resolve( normalizedData );
    }
}
